import React, {createRef, FC, useLayoutEffect} from 'react'
import {TabType} from 'router/settings'

import {Container} from '@mdsol/onex-design'

import {Nav as BSNav, Tab as BSTab} from 'react-bootstrap'
import TabTitle from './TabTitle'

import './tabs.scss'

interface TabsProps {
  routerRefs: object,
  activeTab: TabType,
}

const Tabs: FC<TabsProps> = ({routerRefs, activeTab}) => {
  const homeLinkRef = createRef<HTMLAnchorElement>()

  useLayoutEffect(() => {
    if (activeTab === TabType.home) {
      if (homeLinkRef.current) {
        homeLinkRef.current.click()
      }
    }
  }, [activeTab, homeLinkRef])

  return (
    <Container id='tabs-menu' fluid>
      <BSTab.Container defaultActiveKey={activeTab}>
        <BSNav className='flex-row' variant='tabs'>
          <BSNav.Item>
            <BSNav.Link ref={homeLinkRef} eventKey={TabType.home} {...routerRefs[TabType.home]}>
              <TabTitle tab={TabType.home} isActive={activeTab === TabType.home} />
            </BSNav.Link>
          </BSNav.Item>
          <BSNav.Item>
            <BSNav.Link eventKey={TabType.databases} {...routerRefs[TabType.databases]}>
              <TabTitle tab={TabType.databases} isActive={activeTab === TabType.databases} />
            </BSNav.Link>
          </BSNav.Item>
          <BSNav.Item>
            <BSNav.Link eventKey={TabType.jobs} {...routerRefs[TabType.jobs]}>
              <TabTitle tab={TabType.jobs} isActive={activeTab === TabType.jobs} />
            </BSNav.Link>
          </BSNav.Item>
          <BSNav.Item>
            <BSNav.Link eventKey={TabType.jobRequests} {...routerRefs[TabType.jobRequests]}>
              <TabTitle tab={TabType.jobRequests} isActive={activeTab === TabType.jobRequests} />
            </BSNav.Link>
          </BSNav.Item>
          <BSNav.Item>
            <BSNav.Link eventKey={TabType.diagnostics} {...routerRefs[TabType.diagnostics]}>
              <TabTitle tab={TabType.diagnostics} isActive={activeTab === TabType.diagnostics} />
            </BSNav.Link>
          </BSNav.Item>
        </BSNav>
      </BSTab.Container>
    </Container>
  )
}

export default Tabs
